module.exports = __webpack_public_path__ + "static/7_CloudflareCName-967abcb3921426570e5ca1a211692255.jpg";